import { queryApi } from '../../../api'
import { ENDPOINT } from '../../../constants'
import { IKvitteringData } from '../../../ducks/kvittering/types'
import { IVirksomhetItem } from '../../../ducks/virksomhet-search/types'
import {
  IPrivatAdresse,
  IPrivatAdresseResponse,
  IVirksomhet,
  IVirksomhetAdresseResponse,
} from '../types'

export const adresseApi = {
  getAdresseFromKvittering: async (
    kvittering: IKvitteringData
  ): Promise<IVirksomhet | IPrivatAdresse> => {
    const orgNr = kvittering.virksomhetsOrgNr

    if (orgNr) {
      const { data } = await queryApi.get<IVirksomhetAdresseResponse>(
        `${ENDPOINT.VIRKSOMHET}/virksomheter/orgnummer?filter.orgnummer=${orgNr}`
      )
      return data._embedded.virksomheter[0]
    }

    const { data } = await queryApi.get<IPrivatAdresseResponse>(
      `${ENDPOINT.TILSYNSOBJEKT}/tilsynsobjekter/${kvittering.tilsynsobjekter[0].tilsynsobjektId}/virksomhet`
    )

    return data.adresse
  },
  getAdresseFromVirksomhet: async (virksomhet: IVirksomhetItem) => {
    const orgNr = virksomhet.organisasjonsnummer

    if (orgNr) {
      const { data } = await queryApi.get<IVirksomhetAdresseResponse>(
        `${ENDPOINT.VIRKSOMHET}/virksomheter/orgnummer?filter.orgnummer=${virksomhet.organisasjonsnummer}`
      )
      return data._embedded.virksomheter[0]
    }

    const { data } = await queryApi.get<IPrivatAdresseResponse>(
      `${ENDPOINT.TILSYNSOBJEKT}/tilsynsobjekter/${virksomhet.tilsynsobjekter[0].idstring}/virksomhet`
    )

    return data.adresse
  },
}
